<template>
  <b-modal
    id="org-connectivity-config"
    centered
    hide-header
    hide-footer
    @show="reset"
    @hidden="reset"
  >
    <h3 class="mb-3">Config</h3>
    <form @submit.prevent="save">
      <b-form-group label="Collaboration Server URL">
        <b-form-input
          v-model="form.photon_url"
          placeholder="collaboration.nanome.ai:5055"
        />
      </b-form-group>
      <b-form-group label="MARA URL">
        <b-form-input
          v-model="form.mara_url"
          placeholder="https://mara.nanome.ai"
        />
      </b-form-group>
      <b-form-group label="Workspaces URL">
        <b-form-input
          v-model="form.workspace_url"
          placeholder="https://workspace-repo-api.nanome.ai"
        />
      </b-form-group>
      <div class="mt-4 text-right">
        <b-btn
          class="ml-2 px-4"
          variant="secondary"
          @click="$bvModal.hide('org-connectivity-config')"
        >
          Cancel
        </b-btn>
        <b-btn
          :disabled="!hasChanges"
          class="ml-2 px-4"
          variant="primary"
          type="submit"
        >
          Save
        </b-btn>
      </div>
    </form>
  </b-modal>
</template>

<script>
import API from "@/api";

export default {
  props: {
    org: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    form: {
      mara_url: "",
      photon_url: "",
      workspace_url: ""
    }
  }),

  computed: {
    hasChanges() {
      return (
        this.form.mara_url !== this.org.settings.mara_url ||
        this.form.photon_url !== this.org.settings.photon_url ||
        this.form.workspace_url !== this.org.settings.workspace_url
      );
    }
  },

  methods: {
    reset() {
      this.form.mara_url = this.org.settings.mara_url;
      this.form.photon_url = this.org.settings.photon_url;
      this.form.workspace_url = this.org.settings.workspace_url;
    },

    async save() {
      const { success } = await API.updateOrgConnectivity(this.org.id, {
        mara_url: this.form.mara_url,
        photon_url: this.form.photon_url,
        workspace_url: this.form.workspace_url
      });
      if (!success) return;

      this.$emit("updated");
      this.$bvModal.hide("org-connectivity-config");
      this.$notify({
        type: "success",
        text: "Org config updated"
      });
    }
  }
};
</script>
